<template>
    <span>
        <b-badge :variant="variant">{{ status }}</b-badge>
        <span
            v-if="isErroJob && showErrorBadge"
            class="ml-1 cursor-pointer"
            title="Erro no Job de Integração"
            @click="mostrarModalErroJob"
        >
            <b-badge variant="warning">?</b-badge>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        },
        contrato: {
            type: Object,
            default: null
        },
        showErrorBadge: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            statusPrimary: [
                'ATIVO',
                'ATIVA',
                'SIM',
                'VIGENTE',
                'CADASTRADA',
                'CADASTRADO',
                'OK',
                'PRONTO PARA MIGRAÇÃO',
                'CONTRATO DISTRIBUÍDO',
                'CONTRATO VIGENTE',
                'ADITIVO DISTRIBUÍDO',
                'ADITIVO VIGENTE',
                'NO PRAZO',
                'NADA CONSTA',
                'REGULAR',
                'SUCESSO',
                'ATUALIZADO',
                'APROVADO',
                'VINCULADO A UM PAGAMENTO',
                'APROVADA',
                'PARCELA FIXA',
                'APROVADO',
                'CONVÊNIO VIGENTE',
                'CORREÇÃO EM ANÁLISE - NÃO CONFORME'
            ],
            statusInfo: [
                'PAGA',
                'COMPROMETIDO COM SUCESSO',
                'CONVÊNIO APROVADO',
                'EM ABERTO',
                'ENVIO REGISTRADO',
                'AUTORIZADA'
            ],
            statusSuccess: [
                'PROCESSADA',
                'MIGRADO',
                'REQUISIÇÃO',
                'CONCLUÍDO',
                'CONCLUÍDA',
                'FINALIZADA',
                'ATA CONCLUIDA',
                'ENCAMINHADO',
                'PRÉ-CONTRATO CONCLUÍDO',
                'PADRÃO',
                'CONFERIDO',
                'CONFORME - CONFORME',
                'IRREGULARIDADE CORRIGIDA - CONFORME'
            ],
            statusWarning: [
                'DEVOLVIDA',
                'EM PROCESSAMENTO',
                'FALHA NA MIGRAÇÃO',
                'ERROAPI',
                'ERROINTERNO',
                'SUCESSOCOMRESSALVAS',
                'FALHA NA ATUALIZAÇÃO',
                'ERROSISTEMAREMOTO',
                'DOCUMENTOENTRADAINVALIDA',
                'DOCUMENTOENTIDADENAOENCONTRADA',
                'PARAMETROSINVALIDOS',
                'PARAMETROSNAOSUPORTADOS',
                'SISTEMAREMOTOINDISPONIVEL',
                'TEMPOESGOTADO',
                'TENTATIVASESGOTADAS',
                'LIMITESIMULTANEASATINGIDO',
                'CONSULTAINDISPONIVEL',
                'ACESSONEGADO',
                'FALHAAOREALIZARCONSULTA',
                'PENDENTE',
                'NÃO COMPROMETIDO',
                'EM ANÁLISE',
                'EM PROCESSAMENTO PELO SETOR FINANCEIRO',
                'CONTRATO DISTRIBUÍDO AGUARDANDO INTEGRAÇÃO',
                'INICIADO ADITIVO DE CONTRATO',
                'ADITIVO ASSINADO AGUARDANDO INTEGRAÇÃO',
                'ADITIVO AGUARDANDO JOB DE INTEGRAÇÃO',
                'DEVOLVIDA PARA ANÁLISE',
                'DEVOLVIDA PARA CORREÇÃO',
                'DEVOLVIDO POR FMO',
                'DEVOLVIDO FORA DO PRAZO',
                'ESPECIAL',
                'CONVÊNIO ENCERRADO',
                'NÃO INTEGRADO',
                'ESPECIAL'
            ],
            statusSecondary: [
                'INATIVO',
                'INATIVA',
                'NÃO ATUALIZADO',
                'CONVÊNIO ENCERRADO'
            ],
            statusDanger: [
                'NÃO',
                'VENCIDA',
                'VENCIDO',
                'NOK',
                'FALHA PARA MIGRAÇÃO',
                'CONSTA',
                'IRREGULAR',
                'REPROVADO',
                'REPROVADO PELO SETOR FINANCEIRO',
                'REPROVADA',
                'PRIORITÁRIO',
                'GLOSADO',
                'IRREGULARIDADE NÃO CORRIGIDA - NÃO CONFORME',
                'ERRO NO JOB'
            ],
            statusDark: ['CANCELADA', 'CANCELADO'],
            // Situações que indicam erro no job
            situacoesErroJob: [
                'ERRO NO JOB',
                'ERRO_INTEGRACAO',
                'FALHA NA MIGRAÇÃO',
                'FALHA PARA MIGRAÇÃO',
                'ERROAPI',
                'ERROINTERNO',
                'ERROSISTEMAREMOTO',
                'FALHA NA ATUALIZAÇÃO',
                'FALHAAOREALIZARCONSULTA'
            ]
        }
    },

    computed: {
        variant() {
            if (
                this.statusPrimary.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'primary'
            } else if (
                this.statusInfo.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'info'
            } else if (
                this.statusSuccess.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'success'
            } else if (
                this.statusWarning.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'warning'
            } else if (
                this.statusSecondary.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'secondary'
            } else if (
                this.statusDanger.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'danger'
            } else if (
                this.statusDark.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'dark'
            }
        },

        isErroJob() {
            return this.situacoesErroJob.some((situacao) =>
                this.status.toUpperCase().includes(situacao.toUpperCase())
            )
        }
    },

    methods: {
        mostrarModalErroJob() {
            let conteudoModal = ''

            // Verificar se existe histórico de job no objeto contrato
            if (
                this.contrato &&
                this.contrato.historicoJobIntegracao &&
                this.contrato.historicoJobIntegracao.length > 0
            ) {
                const primeiroErro = this.contrato.historicoJobIntegracao[0]

                conteudoModal = `
                    <div class="text-left">
                        <p>
                            <strong>Situação atual:</strong>
                            <span style="margin-left: 5px;">
                                <small class="badge badge-danger">${
                                    this.status
                                }</small>
                            </span>
                        </p>
                        <p><strong>Data do erro:</strong> ${this.$moment(
                            primeiroErro.data
                        ).format('DD/MM/YYYY HH:mm:ss')}</p>
                        <p>
                            <strong>Situação anterior:</strong>
                                <small class="badge badge-warning">${
                                    primeiroErro.situacaoAnterior
                                        ? primeiroErro.situacaoAnterior.toUpperCase()
                                        : 'N/A'
                                }</small>
                        </p>
                        <p><strong>Observação:</strong> ${
                            primeiroErro.observacao || 'N/A'
                        }</p>
                        <p><strong>Ação recomendada:</strong> Selecione o botão 'Retornar para situação anterior' e escolha a situação específica para corrigir o erro. Caso tenha maiores problemas, entre em contato com o suporte técnico.</p>
                    </div>
                `
            } else {
                // Modal padrão se não houver histórico
                conteudoModal = `
                    <div class="text-left">
                        <p><strong>Status atual:</strong> ${this.status}</p>
                        <p><strong>Descrição:</strong> Ocorreu um erro durante o processamento do job de integração.</p>
                        <p><strong>Possíveis causas:</strong></p>
                        <ul class="text-left">
                            <li>Problemas de conectividade com o sistema remoto</li>
                            <li>Dados inválidos ou incompletos</li>
                            <li>Timeout na execução do job</li>
                            <li>Erro interno do sistema</li>
                        </ul>
                        <p><strong>Ação recomendada:</strong> Entre em contato com o suporte técnico para verificar os logs do job.</p>
                    </div>
                `
            }

            // Mostrar modal com as informações
            this.$swal({
                title: 'Erro no Job de Integração',
                html: conteudoModal,
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#3085d6',
                width: '500px'
            })
        }
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
